import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import { AmplitudeFlagKeys } from '../../resources/amplitude/amplitudeFlags';
import useIsExperimentActive from '../../resources/amplitude/useIsExperimentActive';

const shouldRenderNewOnlineBooking = () => {
  return window.location.href.search('[?&]v2=true') !== -1;
};

const appendStyles = () => {
  document.head.insertAdjacentHTML(
    'beforeend',
    `<style>
  body {
    background: transparent !important;
    height: 100% !important;
    margin: 0 !important;
  }
  html {
    height: 100% !important;
  }
  iframe {
    width: 100% !important;
    height: 100% !important;
    display: block;
  }
  #root {
    width: 100% !important;
    height: 100% !important;
  }
  </style>`
  );
};
export const useInitV1App = () => {
  /**
   * This should be feature flag used to determine if the old app should be rendered.
   * Keep in mind that this FF should be always disabled.
   * In case we wanna rollback the old online booking for pro, we should enable it
   */
  const shouldRenderOldApp = useIsExperimentActive(AmplitudeFlagKeys.allowForOldOnlinebooking);

  useEffect(() => {
    if (shouldRenderOldApp && !shouldRenderNewOnlineBooking()) {
      appendStyles();
      const urlWithoutOrigin = window.location.href.split(window.location.origin)[1];
      const root = document.getElementById('root');
      ReactDOM.render(
        <iframe
          src={`${ONLINE_BOOKING_V1_URL}${urlWithoutOrigin}`}
          width="100%"
          height="100%"
          frameBorder="0"
          title="Online booking"
        />,
        root
      );
    }
  }, [shouldRenderOldApp]);
};
